import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  downloadButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  header: {
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.15px',
    fontHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    fontHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontStyle: theme.typography.fontFamily,
  },
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(0.75),
    gap: theme.spacing(4),
  },
  selectorRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
  },
  timeFrameSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  radioButtonsContainer: {
    marginTop: theme.spacing(2),
  },
  customDateRange: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    paddingTop: theme.spacing(2),
  },
  datePickerContainer: {
    flex: 1,
  },
  selectRowFields: {
    width: '100%',
    maxWidth: theme.spacing(43.5),
  },
}))
